export const EmailProviderType = {
  MAILCHIMP: 'mailchimp',
  CONSTANT_CONTACT: 'constant_contact',
}
